import React, { createContext, useEffect, useMemo, useState } from 'react'
import { categories } from '~2023/utils'

const GlobalContext = createContext()

const GlobalProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [loadingFooter, setLoadingFooter] = useState(true)
  const [loadingHeader, setLoadingHeader] = useState(true)

  const toggleLoading = () => {
    setLoading((value) => {
      return true === value ? false : true
    })
  }

  const toggleLoadingHeader = () => {
    setLoadingHeader((value) => {
      return true === value ? false : true
    })
  }

  const toggleLoadingFooter = () => {
    setLoadingFooter((value) => {
      return true === value ? false : true
    })
  }

  const value = useMemo(
    () => ({
      loading,
      loadingFooter,
      loadingHeader,
      toggleLoading,
      toggleLoadingFooter,
      toggleLoadingHeader,
    }),
    [loading, loadingFooter, loadingHeader]
  )

  const [canRender, setCanRender] = useState(false)

  useEffect(() => {
    if (!canRender) {
      setCanRender(true)
    }
    if (loading) {
      setLoading(false)
    }
  }, [canRender, loading])

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  )
}

const allCategories = categories.map((category) => category.id)

export { allCategories, GlobalProvider }
export default GlobalContext
